import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { useMaterialUIController } from "context";
import { CardActionArea } from "@mui/material";

function DefaultStatisticsCard({ title, count, type, column, selected, handleClick, color }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <Card sx={
      {
        "height":"100%", 
        "border": selected ? "4px solid black" : "2px solid lavender", 
        "backgroundColor": color, 
        // "filter" : selected ? "brightness(115%) saturate(0.9)" : "brightness(100%)",
      }}>
      <CardActionArea onClick={()=> {handleClick(type, column)}} sx={{"height":"100%"}}>
        <MDBox p={2}>
        <Grid container>
          <Grid item xs={12}>
            <MDBox lineHeight={1} sx={{"textAlign": "center"}}>
              <MDTypography variant="h5" fontWeight="bold">
                {count}
              </MDTypography>
              <MDTypography variant="button">
                {title}
              </MDTypography>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      </CardActionArea>
      
    </Card>
  );
}

// Typechecking props for the DefaultStatisticsCard
DefaultStatisticsCard.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default DefaultStatisticsCard;
